var _style, _circle, _circle2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 475.6 475.6",
    style: {
      enableBackground: "new 0 0 475.6 475.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:none;}\r\n\t.st2{fill:#2B388F;}\r\n\t.st3{fill:#FFF100;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 237.8,
    cy: 237.9,
    r: 219.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 243,
    cy: 243.5,
    r: 225
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M238.5,444.9c114-0.4,206.7-93.7,206.3-207.7c-0.4-114-93.5-206.7-207.7-206.3C123,31.3,30.4,124.4,30.8,238.6 C31.2,352.6,124.5,445.3,238.5,444.9z M96.6,242.5l0-7.9c-0.1-14.2,11.4-25.7,25.7-25.8l156.3-0.5c0,0-38-37.7-61.6-61.2 c-10-10-10.1-26.3-0.1-36.3c1.7-1.7,3.3-3.4,5-5c10-10,26.3-10.1,36.3-0.1c30.8,30.6,92,91.4,113.2,112.5c4.8,4.8,7.6,11.3,7.6,18.1 l0,2.2c0,6.7-2.7,13.3-7.4,18.1C350.4,278,289.6,339.1,259,369.9c-10,10-26.3,10.1-36.3,0.1c-1.7-1.7-3.3-3.3-5-5 c-10-10-10.1-26.3-0.1-36.3c23.5-23.5,61.2-61.5,61.2-61.5l-156.3,0.5C108.3,267.8,96.8,256.3,96.6,242.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.4,267.8l156.3-0.5c0,0-37.7,38-61.2,61.5c-10,10-9.9,26.3,0.1,36.3c1.7,1.7,3.3,3.3,5,5 c10,10,26.3,9.9,36.3-0.1c30.6-30.8,91.4-92,112.5-113.2c4.8-4.8,7.5-11.4,7.4-18.1l0-2.2c0-6.8-2.8-13.3-7.6-18.1 c-21.3-21.2-82.4-81.9-113.2-112.5c-10-10-26.3-9.9-36.3,0.1c-1.7,1.6-3.3,3.3-5,5c-10,10-9.9,26.3,0.1,36.3 c23.6,23.4,61.6,61.2,61.6,61.2l-156.3,0.5c-14.2,0.1-25.7,11.6-25.7,25.8l0,7.9C96.8,256.3,108.3,267.8,122.4,267.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M238.6,475.7c131-0.4,237.3-107.5,236.9-238.7C475.2,105.8,368.1-0.3,236.9,0.1C105.7,0.5-0.5,107.6-0.1,238.6 C0.3,369.7,107.4,476.1,238.6,475.7z M30.8,238.6C30.4,124.4,123,31.3,237.1,30.9c114.2-0.4,207.3,92.2,207.7,206.3 c0.4,114-92.2,207.3-206.3,207.7C124.5,445.3,31.2,352.6,30.8,238.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.3ee5fe51dbb35640ec2952df6694c84f.svg";
export { ForwardRef as ReactComponent };